import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Alert.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faXmark,
  faCircleCheck,
  faCircleInfo,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons';

const Alert = ({ show = true, type, message, onClose, redirectTo }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!show) return;
    
    // Auto-cerrar para success e info después de 2 segundos
    if (type === 'success' || type === 'info') {
      const timer = setTimeout(() => {
        onClose?.();
        // Si hay redirect, navegar después de cerrar
        if (redirectTo) {
          navigate(redirectTo);
        }
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose, redirectTo, type, navigate]);

  const iconMap = {
    error: faCircleExclamation,
    info: faCircleInfo,
    success: faCircleCheck,
  };

  if (!show) return null;

  return (
    <>
      {(type === 'error' || type === 'success') && (
        <div className="alert-overlay" />
      )}
      <div className={`alert ${type}`}>
        {(type === 'error' || type === 'success') && !redirectTo && (
          <button className="close-btn" onClick={onClose}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        )}
        <FontAwesomeIcon icon={iconMap[type]} className="alert-icon" />
        <p className="alert-message">{message}</p>
      </div>
    </>
  );
};

export default Alert;
